module.exports = __webpack_public_path__ + "img/tab-9.defda7c3.png";